
import "bootstrap/dist/css/bootstrap.min.css";
import * as React from 'react';
import * as rsuite from 'rsuite';
import Layout from '../../Layout/InnerLayout.js';
import * as General from '../General/General.js';
import * as ReactRouterDOM from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import { ReactSocialMediaIcons } from 'react-social-media-icons';
import { isBrowser } from 'react-device-detect';
import { Helmet } from "react-helmet";

// import GoogleMapReact from 'google-map-react';


const ContactUs = () => {

    //#region Const 
    // const navigate = ReactRouterDOM.useNavigate();

    const toaster = rsuite.useToaster();

    const [Comment, setComment] = React.useState();
    const [Title, setTitle] = React.useState("");
    const [Address, setAddress] = React.useState("");
    const [Tel1, setTel1] = React.useState("");
    const [Tel2, setTel2] = React.useState("");
    const [Mobile, setMobile] = React.useState("");
    const [Email, setEmail] = React.useState("");
    const [Whatsapp, setWhatsapp] = React.useState("");
    const [Instagram, setInstagram] = React.useState("");
    const [Telegram, setTelegram] = React.useState("");
    const [Lon, setLon] = React.useState("");
    const [Lat, setLat] = React.useState("");

    // const location = {
    //     address: <rsuite.Image src="../../../../assets/images/Store.jpg" style={{ width: '70px', height: '100px' }} />,//"پاساژ ملت فروشگاه مهران  - فارم آسان.",
    //     lat: Lat,
    //     lng: Lon,
    // };


    // const LocationPin = ({ text }) => (
    //     <div className="pin">
    //         <BiIcon.BiSolidMap className="pin-icon" />
    //         <p className="pin-text">{text}</p>
    //     </div>
    // );

    const Get = () => {
        fetch(General.ApiRoute() + '/AboutUs/GetForWeb', {
            method: 'Get',
            headers: {
                'ApiKey': General.APIKey(),
            },
            credentials: 'include'
        })
            .then(res => res.json())
            .then(result => {
                setComment(result.comment);
                setTitle(result.title);
                setAddress(result.address);
                setTel1(result.tel1);
                setTel2(result.tel2);
                setMobile(result.mobile);
                setEmail(result.email);
                setWhatsapp(result.whatsapp);
                setInstagram(result.instagram);
                setTelegram(result.telegram);
                setLat(result.lat);
                setLon(result.lon);
                // setbackground("");
            })

    }



    //#endregion
    React.useEffect(() => {
        Get()
        document.title = "تماس با ما";
    }, [])


    return (
        <Layout>
            <Helmet>
                <title>فروشگاه فارم آسان | تجهیزات کشاورزی و صنعتی</title>
                <meta
                    name="description"
                    content="بازرگانی فارم آسان؛ عرضه‌کننده انواع تجهیزات کشاورزی، موتور برق، پمپ، کارواش، سمپاش و ابزار صنعتی در شیراز."
                />
            </Helmet >
            <div className="ProductInfoBanner">
                تماس با ما
            </div>

            <h1 className="ProductInfoAddressBar mb-0">
                <rsuite.Breadcrumb >
                    <rsuite.Breadcrumb.Item style={{ fontSize: "13px" }} href="/">
                        خانه
                    </rsuite.Breadcrumb.Item>
                    <rsuite.Breadcrumb.Item style={{ color: '#3b6682', fontSize: "13px" }}>تماس ما</rsuite.Breadcrumb.Item>
                </rsuite.Breadcrumb>

            </h1>

            <rsuite.Grid className="pt-3 pb-4">

                <rsuite.Row className="justify-content-center align-items-center mt-5 mb-0">

                    <rsuite.Col xs={24} md={12} className="p-3">
                        <p >
                            <rsuite.Heading level="6">ارتباط با ما</rsuite.Heading>

                            <p className='mt-3 fw-bold Font13'>{Title}</p>
                            <p><b>شماره تماس  </b> {Tel1}</p>
                            <p><b>شماره تماس  </b> {Tel2} </p>
                            <p><b>شماره همراه  </b>  {Mobile}</p>
                            <p><b>آدرس </b>  {Address}</p>

                        </p>
                        <p className="text-center mt-4 pt-4">
                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="instagram"
                                iconColor="rgb(230, 13, 13)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url={Instagram} size="40" />
                            {/* "https://www.instagram.com/farm.asan?igsh=Nzd5d3dyNWY2MzJz" */}
                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="whatsapp"
                                iconColor="rgb(16, 107, 29)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url={Whatsapp} size="40" />
                            {/* "https://wa.me/+989101172004" */}
                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="map"
                                iconColor="rgb(16, 77, 143)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url="https://maps.app.goo.gl/1vqVsQ67XDTQKxSF9" size="40" />

                            <ReactSocialMediaIcons className='pe-2 ps-2' borderColor="rgb(251, 251, 252, 0.0)" icon="mail"
                                iconColor="rgb(34, 38, 41)" backgroundColor="rgb(251, 251, 252, 0.0)"
                                url={Email} size="40" />

                            {/* "https://mail.google.com/mail/?view=cm&fs=1&to=Asma.dehghani@gmail.com" */}


                        </p>


                    </rsuite.Col>
                    <rsuite.Col xs={24} md={12}>
                        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d433.54873741259553!2d52.54506809292532!3d29.621417033315133!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3fb20dd0a8eeadff%3A0x3959d6d3d76574f9!2z2K7bjNin2KjYp9mGINiz2LnYr9uM2IzZvtin2LPYp9qY2YXZhNiq!5e0!3m2!1sen!2s!4v1737957537053!5m2!1sen!2s"
                            width="100%" height="400" style={{ border: "0" }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade">
                        </iframe>
                    </rsuite.Col>
                </rsuite.Row>
                <rsuite.Row className="mt-0">


                    <rsuite.Col xsHidden smHidden md={12} className="pb-3">
                        <rsuite.Image src="../../../../assets/images/Store.jpg" style={{ height: '400px', width: '100%' }} />



                    </rsuite.Col>
                    <rsuite.Col xs={24} md={12} className=" mt-4 pt-3 ">

                        <rsuite.InputGroup inside >
                            <rsuite.InputGroup.Addon><BiIcon.BiUser /></rsuite.InputGroup.Addon>
                            <rsuite.Input placeholder="نام و نام خانوادگی خود را وارد کنید"></rsuite.Input>
                        </rsuite.InputGroup>
                        <rsuite.InputGroup className="mt-2" inside >
                            <rsuite.InputGroup.Addon><BiIcon.BiMobile /></rsuite.InputGroup.Addon>
                            <rsuite.Input defaultValue="09" placeholder="شماره تماس خود را وارد کنید"></rsuite.Input>
                        </rsuite.InputGroup>

                        <rsuite.InputGroup className="mt-2" inside >
                            <rsuite.InputGroup.Addon><BiIcon.BiMailSend /></rsuite.InputGroup.Addon>

                            <rsuite.Input placeholder=" ایمیل خود را وارد کنید"></rsuite.Input>
                            <rsuite.InputGroup.Addon>.com</rsuite.InputGroup.Addon>
                        </rsuite.InputGroup>
                        <rsuite.InputGroup className="mt-2" inside >
                            <rsuite.InputGroup.Addon><BiIcon.BiMessage /></rsuite.InputGroup.Addon>

                            <rsuite.Input as="textarea" rows={6} placeholder=" متن خود را وارد کنید"></rsuite.Input>
                        </rsuite.InputGroup>
                        <rsuite.Button className="mt-4" color="green" appearance="primary" block>  ارسال    </rsuite.Button>

                    </rsuite.Col>

                </rsuite.Row>
            </rsuite.Grid>





        </Layout >
    )
}

export default ContactUs;